// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>2</span>&nbsp;&nbsp;Let us come into his presence with thanksgiving&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and be glad in him with psalms.<br> </p> </div></div>";
// Exports
module.exports = code;